
// Main permissions structure organized by category
export const Permissions = {
  Pipeline: {
    Loan: {
      FullControl: "Loan.FullControl",
      Read: "Loan.Read",
      Export: "Loan.Export",
      ReadBranch: "Loan.ReadBranch",
      ReadAll: "Loan.ReadAll"
    },
    Report: {
      FullControl: "Report.FullControl",
      Read: "Report.Read",
      Export: "Report.Export"
    },
    Goal: {
      FullControl: "Goal.FullControl",
      Read: "Goal.Read",
      Write: "Goal.Write"
    },
    Ranking: {
      Read: "Ranking.Read"
    }
  },
  Payroll: {
    Payroll: {
      FullControl: "Payroll.FullControl",
      Read: "Payroll.Read",
      Export: "Payroll.Export"
    }
  },
  Education: {
    TrainingResource: {
      FullControl: "TrainingResource.FullControl",
      Read: "TrainingResource.Read",
      Write: "TrainingResource.Write"
    },
    Compliance: {
      FullControl: "Compliance.FullControl",
      Read: "Compliance.Read",
      Write: "Compliance.Write",
      Quiz: "Compliance.Quiz"
    }
  },
  MarketingHub: {
    MarketingResource: {
      FullControl: "MarketingResource.FullControl",
      Read: "MarketingResource.Read", // External roles can read, such as: Partner, VirtualAssistant.
      Write: "MarketingResource.Write"
    }
  },
  CRM: {
    Campaign: {
      FullControl: "Campaign.FullControl",
      Read: "Campaign.Read",
      Write: "Campaign.Write",
      Activate: "Campaign.Activate"
    }
  },
  Calculator: {
    Calculator: {
      FullControl: "Calculator.FullControl"
    },
    IncomeCalculator: {
      Read: "IncomeCalculator.Read" // External roles can read, such as: Partner, VirtualAssistant.
    },
    SaleCalculator: {
      Read: "SaleCalculator.Read"
    },
    CalculatorScenario: {
      Read: "CalculatorScenario.Read",
      Write: "CalculatorScenario.Write",
      Delete: "CalculatorScenario.Delete"
    }
  },
  Management: {
    User: {
      Read: "User.Read",
      FullControl: "User.FullControl"
    },
    Role: {
      Read: "Role.Read",
      FullControl: "Role.FullControl"
    },
    Borrower: {
      FullControl: "Borrower.FullControl"
    },
    Lender: {
      FullControl: "Lender.FullControl"
    },
    Branch: {
      Read: "Branch.Read",
      FullControl: "Branch.FullControl"
    },
    LoanTeam: {
      Read: "LoanTeam.Read",
      FullControl: "LoanTeam.FullControl"
    }
  },
  Other: {
    EmployeeDirectory: {
      Read: "EmployeeDirectory.Read"
    },
    Investor: {
      Read: "Investor.Read"
    }
  }
} as const;

export class PermissionConstants {
  // Reference to the main permissions structure for backward compatibility
  static readonly Permissions = Permissions;
}

/**
 * Helper type to get all permission category names
 */
export type PermissionCategory = keyof typeof Permissions;

/**
 * Helper type to get all entity names for a specific category
 */
export type PermissionEntity<T extends PermissionCategory> = keyof typeof Permissions[T];

/**
 * Helper type to get all action names for a specific entity in a category
 */
export type PermissionAction<
  TCategory extends PermissionCategory,
  TEntity extends PermissionEntity<TCategory>
> = keyof typeof Permissions[TCategory][TEntity];
